export const EPOCH_START = '1970-01-01T00:00:00.000Z';

export const AMAZON_OWNERNAME = 'Amazon';

export const FILTER_DROPDOWN_WIDTH = '200px';
export const FILTER_DROPDOWN_CUSTOM_DATE_WIDTH = '400px';
export const FILTER_BY_HEIGHT_REGULAR = 60;
export const FILTER_BY_HEIGHT_SHORT = 20;

export const FILTER_BAR_HEIGHT_THRESHOLD = 90;
export const FILTER_BAR_ID = 'filter-bar';

export const CUSTOMER_COMMENTS_MAX_WIDTH = '1080px';

export const CONSOLIDATED_CONTACT_CATEGORY = {
  CONCESSION_COMPLIANCE: 'Concession Compliance',
};
